export default {"src":"/_next/static/media/amenityIcon-catering.8bf68e6e.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};